import type { ReactNode } from 'react';
import {
  ImageHeader,
  BreadcrumbContainer,
  LastUpdated,
} from '@/components/Header';
import Breadcrumb from '@/components/Breadcrumb';
import { Criteria } from '../Criteria';
import { getGridViewCoverFromImageUrl } from '@/utilities/coverImages';
import { useCloudflareImage } from '@/hooks/useCloudflareImage';
import { PageDescription } from './styled';
import { Grid, Heading } from '@simplywallst/ui-core';
import type { PageType } from '@/pages/DiscoverPageV2/constants';

interface BreadCrumb {
  name: string;
  dispatch?: ReducerAction;
}

const COVER_IMG_WIDTH = 1152;
const COVER_IMG_HEIGHT = 196;

interface Props {
  pageType: PageType;
  title: string;
  imageUrl: string | null;
  description: ReactNode;
  breadCrumbs: BreadCrumb[];
}

const Header = ({
  pageType,
  title,
  imageUrl,
  description,
  breadCrumbs,
}: Props) => {
  const coverImageSrc = useCloudflareImage({
    src: getGridViewCoverFromImageUrl(imageUrl),
    width: COVER_IMG_WIDTH,
    height: COVER_IMG_HEIGHT,
    fit: 'cover',
    quality: 30,
  });
  return (
    <>
      <ImageHeader
        alt={title}
        imageSource={coverImageSrc}
        width={COVER_IMG_WIDTH}
        height={COVER_IMG_HEIGHT}
      >
        <Grid
          templateRows="1fr"
          templateColumns="1fr"
          templateRowsMd="1fr"
          templateColumnsLg="1fr 362px"
          columnGapMd="32px"
          data-cy-id="discover-header"
        >
          <PageDescription>
            <BreadcrumbContainer>
              <Breadcrumb list={breadCrumbs} />
            </BreadcrumbContainer>
            <Heading as="h1" typography="heroStrong">
              {title}
            </Heading>
            <LastUpdated />
            {description}
          </PageDescription>
        </Grid>
      </ImageHeader>
      <Criteria pageType={pageType} />
    </>
  );
};

export default Header;
